import {injectGlobal} from "styled-components";
import colors from "./constants/colors";
import fonts from "./constants/fonts";

injectGlobal`
  html,
  body {
    margin: 0;
    min-height: 100vh;
    max-width: 100vw;
    justify-content: center;
    /* height: 100%;
    width: 100%; */
    display: block;
    overflow-x: hidden;
    overflow-y: auto;
    scroll-behavior: smooth;
    color: #4D4D4D;
    font-family: ${fonts.primary}, Helvetica, sans-serif;
    font-weight: 400;
    & button {
      padding: 0 16px;
      font-family: ${fonts.primary}, Helvetica, sans-serif;
    }
  }

  input {
    font-family: ${fonts.primary}, Helvetica, sans-serif;
    font-weight: 400;
  }

  input[type=text]{
    -webkit-appearance: none;
     border-radius: 0;
  }

  *::-webkit-scrollbar {
    width: 0px;  /* remove scrollbar space */
    background: transparent;  /* optional: just make scrollbar invisible */
  } 

  ::selection {
    /* background: ${colors.purpleLightissimo} !important;
    color: ${colors.gray} */
  }
  

  * { 
    box-sizing: border-box;
    font-family: ${fonts.primary}, Helvetica, sans-serif;
    font-weight: 400;
    text-rendering: optimizeLegibility; 
    -webkit-font-smoothing: antialiased; 
    -moz-osx-font-smoothing: grayscale;
  }

  *::-webkit-scrollbar {
    display: none !important;
    }
  
  body {
    font-family: ${fonts.primary}, Helvetica, sans-serif;
  }
`;
